import { render, staticRenderFns } from "./radioBox.vue?vue&type=template&id=6331272f&"
import script from "./radioBox.vue?vue&type=script&lang=js&"
export * from "./radioBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/items/radioBox.vue"
export default component.exports